// Note: these map to server result enum values
export const ProgramStatusType = Object.freeze({
  NotStarted: 'NotStarted',
  InProgress: 'InProgress',
  Complete: 'Complete',
  TierRequirementsIncomplete: 'TierRequirementsIncomplete'
});
